module.exports = __webpack_public_path__ + "a2d55c21cb89fa14cdf0fad4d9367721.png";